import { render, staticRenderFns } from "./CompareTree.vue?vue&type=template&id=071d2fce&scoped=true"
import script from "./CompareTree.vue?vue&type=script&lang=js"
export * from "./CompareTree.vue?vue&type=script&lang=js"
import style0 from "./CompareTree.vue?vue&type=style&index=0&id=071d2fce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d2fce",
  null
  
)

export default component.exports